import { render, staticRenderFns } from "./LineOrgTag.vue?vue&type=template&id=6068ad3c&scoped=true";
import script from "./LineOrgTag.vue?vue&type=script&lang=js";
export * from "./LineOrgTag.vue?vue&type=script&lang=js";
import style0 from "./LineOrgTag.vue?vue&type=style&index=0&id=6068ad3c&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "6068ad3c", null);
export default component.exports;